import type { AuthRepository } from '@/domain/auth/AuthRepository'
import type { LoginResponse } from '@/domain/auth/LoginResponse'
import { LoginCheckService } from '../api/services/LoginCheckService'
import { OpenAPI } from '../api'
import { UserService } from '../api/services/UserService'
import type { User } from '@/domain/auth/User'
import type { UserClient } from '@/domain/auth/UserClient'
import { UserClientService } from '../api/services/UserClientService'
import type { RegisterRequest } from '@/domain/auth/RegisterRequest'
import type { User_user_write } from '../api/models/User_user_write'

export class ApiAuthRepository implements AuthRepository {
  async login(email: string, pass: string): Promise<LoginResponse> {
    const response = await LoginCheckService.loginCheckPost({
      email: email,
      password: pass
    })

    OpenAPI.TOKEN = response.token as string

    return response as LoginResponse
  }

  async register(request: RegisterRequest): Promise<User> {
    const response = await UserService.userRegister(request as unknown as User_user_write)
    return response as unknown as User
  }

  async findAll(): Promise<User[]> {
    const response = await UserService.apiV1UsersGetCollection()
    return response as User[]
  }

  async findAllUserClients(): Promise<UserClient[]> {
    const response = await UserClientService.apiV1UserClientsGetCollection()
    return response as unknown as UserClient[]
  }
}
